//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.DialogsAdmInterniSubjekt.ts						</Name>
//    <Description> Funkce pro otev�en� dialog� spojen�ch s Extern� subjekt </Description>
//    <Author>      FFIALA													</Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-03-15                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.16.3
//AdtGeneratorConfig:[ T:(ginsesu) GID:(Web.Dia.Ts) V1:(ixs_esu,aktivita,dat_zmena,zmenu_prov,zkratka,nazev,ob_jmeno,typ_esu,ixs_nad,stat,psc,obec,cast_obce,ulice,cor,cpop,ico,dic,tel,mail,typ_org) V2:(aktivita) K1:(f_ginsesu_typ_adr,f_ginsesu_typ_esu,f_ginsesu_typ_org) K2:(f_ginsesu_stat,lf_ginsesu_psc) K3:() ]

namespace Gordic.Adm.Dialogs {

    // AdmInterniSubjekt
    export function DetailAdmInterniSubjektDlg(
        parentContent: GContent,
        opt: {
            /** ixs_esu */
            ixs_esu: string | null,
            /** grid jquery element */
            grid?: JQuery<HTMLElement>,
            /** p��znak nov�ho z�znamu */
            newRecord?: boolean
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

    const deferred = $.Deferred();
    const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
    ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

    let isValid = true;
    var detailCommand = opt.grid ? false : true;

    // grid remote control, kv�li �ipk�m na detailu
    const gridRemoteControl = opt && opt.grid ? new Gordic.Components.GridRC(opt.grid) : undefined;

    var detail = ['Gordic.Adm.WebControls.DetailAdmInterniSubjekt', { gridRemoteControl: gridRemoteControl }]

    const options = {
        ID: "AdmAdmInterniSubjekt#",
        ixs_esu: opt ? opt.ixs_esu : undefined,
        newRecord: opt ? opt.newRecord : undefined,
        detailCommand: detailCommand
    };

    if (isValid) {
        //RC 32131033 : Detail
        Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
    } else {
        deferred.reject();
    }
    return deferred.promise();
}

    // AdmInterniSubjekt
    export function SeznamAdmInterniSubjektDlg(
        parentContent: GContent,
        opt: {
            /** ixs_esu */
            ixs_esu: string | null,
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

    const deferred = $.Deferred();
    const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
    ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

    let isValid = true;

    var detail = ['Gordic.Adm.WebControls.SeznamAdmInterniSubjekt', { }]

    const options = {
        ID: "AdmAdmInterniSubjekt#",
        ixs_esu: opt ? opt.ixs_esu : undefined,
    };

    if (isValid) {
        //RC 32131033 : Detail
        Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
    } else {
        deferred.reject();
    }
    return deferred.promise();
  }

}
